module.exports = __webpack_public_path__ + "static/img/erwei_baoming.9d48838.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/erwei_baoming.png
// module id = N6V8
// module chunks = 18